var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-width":"1400px"}},[_c('div',{staticClass:"about fl-s-c"},[_c('p',{staticClass:"about-title"},[_vm._v(_vm._s(_vm.pname))]),_c('el-divider',{staticClass:"row-line"}),(_vm.html)?_c('div',{staticClass:"rich-text w-1",domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }